var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delay-node-sidebar"},[_c('select-input',{staticClass:"mt-0",attrs:{"setup":{
      'func': _vm.swipeDelayType,
      'args': {
        'model': _vm.node.data.delay,
        'key': 'type',
        'options': _vm.getDelayTypeOptions,
        'prefix': 'delay_',
        'clearable': false,
      }
    }}}),(_vm.node.data.delay instanceof _vm.ProxyDelayDateType)?_c('delay-date-type',{key:("delay-date-type-" + (_vm.node.id)),attrs:{"delay":_vm.node.data.delay}}):_vm._e(),(_vm.node.data.delay instanceof _vm.ProxyDelayIntervalType)?_c('delay-interval-type',{key:("delay-interval-type-" + (_vm.node.id)),attrs:{"delay":_vm.node.data.delay}}):_vm._e(),(_vm.node.data.delay instanceof _vm.ProxyDelayPropertyType)?_c('delay-property-type',{key:("delay-property-type-" + (_vm.node.id)),attrs:{"delay":_vm.node.data.delay}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }